// Marker's own inventory, shown to every organization because `auto` persona
// selection already places calls from it. The address is Marker's, not this
// org's, so the row reads generically and the real number sits behind the
// `i`. The section renders only when the shared pool actually has rows — an
// empty platform pool is not a feature to advertise.
import { phoneNumberLabel, type PhoneNumber } from "../lib/phoneNumbers";
import { Badge, HelpTip, Inline, Section, Stack, Text } from "../ui";

export function SharedNumbers({
  numbers,
}: {
  numbers: readonly PhoneNumber[];
}) {
  if (numbers.length === 0) {
    return null;
  }
  return (
    <Section
      description="Marker owns these and every organization can use them. They cost you nothing, do not count against your limit, and cannot be released or pinned to a persona."
      heading="Shared Marker numbers"
    >
      <Stack>
        {numbers.map((number) => (
          <Inline key={number.id}>
            <Text>{phoneNumberLabel(number)}</Text>
            <HelpTip
              label={`Show the number behind ${phoneNumberLabel(number)}`}
            >
              {`Calls from ${phoneNumberLabel(number)} arrive as \`${number.address}\`. It is shared Marker inventory, so other organizations use it too.`}
            </HelpTip>
            <Badge>{number.status}</Badge>
            <Text>
              {number.max_concurrent_calls} concurrent calls per number
            </Text>
          </Inline>
        ))}
      </Stack>
    </Section>
  );
}
